import { axiosBase, axiosDevelopment } from './config';

export const MediaService = {
    GET_VIDEOS(userID, sessionID, sorting, pagination, search) {
        return axiosBase.get(`f2020_get_videos?u=${userID}&sn=${sessionID}&s=${sorting}&p=${pagination}&srch=${search}`);
    },
    GET_FILES(userID, sessionID, sorting, pagination, search) {
        return axiosBase.get(`f2020_get_files?u=${userID}&sn=${sessionID}&s=${sorting}&p=${pagination}&srch=${search}`);
    },
    GET_IMAGES(userID, sessionID, sorting, pagination, search) {
        return axiosBase.get(`f2020_get_images?u=${userID}&sn=${sessionID}&s=${sorting}&p=${pagination}&srch=${search}`);
    },
    GET_LICENSED_VIDEOS(userID, sessionID, sorting, pagination, search) {
        return axiosBase.get(`f2020_get_licenced_videos?u=${userID}&sn=${sessionID}&s=${sorting}&p=${pagination}&srch=${search}`);
    },
    GET_DICTIONARY(){
        return axiosDevelopment.get("dictionary")
    },
    POST_MEDIA(data) {
        return axiosDevelopment.post(`ajax/upload-content`, data);
    },
    POST_FILE_CONTENT(data, config) {
        return axiosDevelopment.post("ajax/upload-file-content", data, config)
    },
    POST_GENERATE_LINK(data, config) {
        return axiosDevelopment.post("generate-link", data, config)
    },
};